import { Draft, produce } from 'immer';
import { getType } from 'typesafe-actions';

import { Action } from '../actions';
import { cancelModerationMessage, confirmModerationMessage, showModerationMessage } from '../actions/messages';
import { MessagesState, MessageType } from '../typings/messagesState';

const DefaultMessagesState = {
    items: []
};

export function messages(state: MessagesState = DefaultMessagesState, action: Action): MessagesState {
    return produce(state, (draft: Draft<MessagesState>) => {
        switch (action.type) {
            case getType(showModerationMessage):
                draft.items = [
                    {
                        type: MessageType.MODERATION,
                        payload: {
                            campaignId: action.campaignId
                        }
                    }
                ];

                return;
            case getType(confirmModerationMessage):
            case getType(cancelModerationMessage):
                draft.items = [];

                return;
            default:
                return;
        }
    });
}
